(function () {
    const fetchOriginal = window.fetch;
    let peticionesActivas = 0;
    let operacionesBloqueantes = 0;
    const estados = [];

    if (typeof fetchOriginal !== "function") return;

    const actualizarCargando = () => {
        const cargando = document.querySelector(".cont-cargando");
        if (!cargando) return;

        const mostrar = peticionesActivas > 0;
        const estado = estados[estados.length - 1] || {};
        cargando.classList.toggle("cont-cargando--show", mostrar);
        cargando.setAttribute("aria-hidden", mostrar ? "false" : "true");

        const titulo = cargando.querySelector(".cargando-titulo");
        const detalle = cargando.querySelector(".cargando-detalle");
        const aviso = cargando.querySelector(".cargando-aviso");
        if (titulo) titulo.textContent = estado.titulo || "Procesando solicitud";
        if (detalle) detalle.textContent = estado.detalle || "Espera un momento, por favor.";
        if (aviso) aviso.hidden = estado.bloquearSalida === false;
    };

    window.addEventListener("beforeunload", (event) => {
        if (operacionesBloqueantes === 0) return;
        event.preventDefault();
        event.returnValue = "";
    });

    window.fetch = function (...argumentos) {
        // Las peticiones marcadas con `sinCargando` (cargas de tabla en segundo
        // plano que ya muestran su propio esqueleto) no bloquean toda la pantalla.
        const opciones = argumentos[1] || {};
        const omitir = opciones.sinCargando === true;
        const metodo = String(opciones.method || "GET").toUpperCase();
        const bloquearSalida = opciones.bloquearSalida === true || metodo === "POST";
        const estado = {
            titulo: opciones.mensajeCargando,
            detalle: opciones.detalleCargando,
            bloquearSalida,
        };

        if (!omitir) {
            peticionesActivas += 1;
            estados.push(estado);
            if (bloquearSalida) operacionesBloqueantes += 1;
            actualizarCargando();
        }

        return fetchOriginal.apply(this, argumentos).finally(() => {
            if (!omitir) {
                peticionesActivas = Math.max(0, peticionesActivas - 1);
                const indice = estados.indexOf(estado);
                if (indice >= 0) estados.splice(indice, 1);
                if (bloquearSalida) {
                    operacionesBloqueantes = Math.max(0, operacionesBloqueantes - 1);
                }
                actualizarCargando();
            }
        });
    };
})();
